var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4348 16.6H12.0348V15.4H11.4348V16.6ZM1 15.4H0.4V16.6H1V15.4ZM6.21753 0.999985L6.6418 0.575724L6.21753 0.151452L5.79326 0.575721L6.21753 0.999985ZM11.4348 15.4H1V16.6H11.4348V15.4ZM11.207 5.14099L6.6418 0.575724L5.79326 1.42425L10.3584 5.98951L11.207 5.14099ZM5.61753 6.54346V12.0869H6.81753V6.54346H5.61753ZM5.61753 0.999985V3.77172H6.81753V0.999985H5.61753ZM5.61753 3.77172V6.54346H6.81753V3.77172H5.61753ZM5.79326 0.575721L3.51064 2.85835L4.35917 3.70688L6.64179 1.42425L5.79326 0.575721ZM3.51064 2.85835L1.22802 5.14098L2.07655 5.98951L4.35917 3.70688L3.51064 2.85835Z",
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.0d17b9b3a38db3194e67cfa3cada6019.svg";
export { ForwardRef as ReactComponent };